import React, { useState, useEffect } from 'react';
import './App.css';
import { getApiUrl } from './apiConfig';

const initialOfficers = [
    {
        office: "පළාත් කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය",
        officer: "ඩබ්.එම්.එන්.එස්. වනසුන්දර",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ (මූලස්ථාන)"
    },
    {
        office: "නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය, රත්නපුර",
        officer: "ජේ.පී. ගුණවර්ධන",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය, කෑගල්ල",
        officer: "ආර්.පී.එන්.එල්.රාජපක්ෂ",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "නියෝජ්‍ය කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , රත්නපුර",
        officer: "පී.අයි.පී.එම් පුස්සැල්ල",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , නිවිතිගල",
        officer: "එච්.පී.ඩබ්.නිලන්ති",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , බළන්ගොඩ-",
        officer: "එස්.එම්.සී.පී.සිරිවර්ධන",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , ඇඹිලිපිටිය",
        officer: "එස්.එන්.කේ.සරණසිංහ",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , කෑගල්ල",
        officer: "පී.ජී.ආර්.එස්.වෙළගෙදර",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය , රුවන්වැල්ල",
        officer: "කේ.ඒ. නිලන්ති විජේසිංහ",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කාර්යාලය ,බැමිණිවත්ත, මාවනැල්ල",
        officer: "ඒ.ජී.ඒ.එන්.එල්.ජයරත්න",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    },
    {
        office: "සේවා සංස්කරණ අභ්‍යාස ආයතනය , ගොඩකුඹුර ,රජවක",
        officer: "එස්.එම්.සී.පී.සිරිවර්ධන",
        title: "තොරතුරු දැනගැනීමේ නිලධාරී",
        position: "සහකාර කෘෂිකර්ම අධ්‍යක්ෂ"
    }
];

export default function Infor({ onBackClick }) {
    const [officers, setOfficers] = useState(() => {
        try {
            const local = localStorage.getItem('site_rti_officers');
            if (local) {
                const parsed = JSON.parse(local);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed;
            }
        } catch (e) {}
        return initialOfficers;
    });

    useEffect(() => {
        const fetchRtiData = async () => {
            try {
                const res = await fetch(getApiUrl(`api_rti.php?t=${Date.now()}`));
                if (res.ok) {
                    const data = await res.json();
                    if (Array.isArray(data) && data.length > 0) {
                        setOfficers(data);
                        try { localStorage.setItem('site_rti_officers', JSON.stringify(data)); } catch (e) {}
                        return;
                    }
                }
                throw new Error('API fetch failed');
            } catch (err) {
                try {
                    const staticRes = await fetch(`/rti_data.json?t=${Date.now()}`);
                    if (staticRes.ok) {
                        const staticData = await staticRes.json();
                        if (Array.isArray(staticData) && staticData.length > 0) {
                            setOfficers(staticData);
                        }
                    }
                } catch (staticErr) {
                    // Fallback remains initialOfficers
                }
            }
        };

        fetchRtiData();
    }, []);

    const data = officers;

    return (
        <main className="about-overview-container">
         <button
                className="back-button"
                onClick={() => onBackClick && onBackClick('home')}
                style={{
                    backgroundColor: '#0b6b2f',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                }}
            >
                ← ආපසු
            </button>
            <div className="about-overview-inner" style={{ display: 'block' }}>
                <div className="about-overview-content" style={{ maxWidth: '900px', margin: '0 auto', width: '100%' }}>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <h1 className="about-overview-title" style={{ fontSize: 'clamp(24px, 5vw, 32px)', marginBottom: '10px', textAlign: 'justify' }}>තොරතුරු දැනගැනීමේ නිලධාරීන්</h1>
                        <div style={{ height: '4px', maxWidth: '100%', width: '100%', background: '#0b6b2f', margin: '0 auto', borderRadius: '2px' }}></div>
                    </div>

                    <div className="info-table-wrapper" style={{
                        background: '#fff',
                        borderRadius: '15px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                        overflow: 'hidden',
                        border: '1px solid #eee'
                    }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ background: '#0b6b2f', color: '#fff' }}>
                                    <th style={{ padding: '20px', textAlign: 'left', fontWeight: '600', fontSize: '18px', width: '45%' }}>කාර්යාලය</th>
                                    <th style={{ padding: '20px', textAlign: 'left', fontWeight: '600', fontSize: '18px' }}>තොරතුරු දැනගැනීමේ නිලධාරී විස්තර</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} style={{
                                        borderBottom: idx === data.length - 1 ? 'none' : '1px solid #f0f0f0',
                                        transition: 'background 0.2s'
                                    }}
                                        onMouseOver={(e) => e.currentTarget.style.background = '#fcfcfc'}
                                        onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                                    >
                                        <td style={{ padding: '20px', verticalAlign: 'top' }}>
                                            <div style={{ color: '#0b6b2f', fontWeight: '700', fontSize: '16px', lineHeight: '1.5' }}>
                                                {item.office}
                                            </div>
                                        </td>
                                        <td style={{ padding: '20px' }}>
                                            <div style={{ marginBottom: '8px' }}>
                                                <div style={{ fontWeight: '700', fontSize: '17px', color: '#333' }}>{item.officer}</div>
                                                <div style={{ color: '#0b6b2f', fontWeight: '600', fontSize: '14px', marginTop: '2px' }}>{item.title}</div>
                                                <div style={{ color: '#666', fontSize: '14px', marginTop: '2px' }}>{item.position}</div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '30px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
                        <p>සබරගමුව පළාත කෘෂිකර්ම දෙපාර්තමේන්තුව - තොරතුරු දැනගැනීමේ අයිතිවාසිකම සුරකිමු</p>
                    </div>
                </div>
            </div>
        </main>
    );
}